{
  "type": "object",
  "name": "FindVoucher",
  "class": "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 auto-rows-auto gap-4",
  "definitions": [
    {
      "type": "date",
      "name": "from",
      "title": "Von Datum",
      "required": true,
      "class": "",
      "default": "h-3m"
    },
    {
      "type": "date",
      "name": "to",
      "title": "Bis Datum",
      "required": true,
      "class": "",
      "default": "h"
    },
    {
      "type": "string",
      "name": "bezugsnummer",
      "title": "Fremdbelegsnummer",
      "class": ""
    },
    {
      "type": "fieldOk",
      "name": "kontoKreditor",
      "title": "Lieferant",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.lieferant",
      "parameters": {
        "aktivfirma": 0,
        "aktiv": 0,
        "geloescht": 0,
        "sperre": 0
      },
      "class": "md:col-span-2 lg:col-span-1",
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "nummer",
              "title": "Nummer"
            },
            {
              "type": "string",
              "class": "",
              "name": "kurzbez",
              "title": "Bezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "name1",
              "title": "Name"
            },
            {
              "type": "string",
              "class": "",
              "name": "postleitzahl",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "ort",
              "title": "Ort"
            },
            {
              "type": "string",
              "class": "",
              "name": "strasse",
              "title": "Straße"
            }
          ]
        }
      }]
    },
    {
      "type": "fieldOk",
      "name": "kontoLieferadresse",
      "title": "Baustelle",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{kurzbez}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "parameters": {
        "geloescht": 0,
        "gesperrt": 0,
        "kategorie": 2,
        "freigabedatum": "Alle",
        "KUNDENABFRAGE_KENNZEICHEN_AKTIV": "ALLE",
        "kundennummer": {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "ktostammnummer"
        }
      },
      "class": "md:col-span-2 lg:col-span-1",
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "8",
              "title": "Kostenstelle"
            },
            {
              "type": "string",
              "class": "",
              "name": "1",
              "title": "Kurzbezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "13",
              "title": "Straße"
            },
            {
              "type": "string",
              "class": "",
              "name": "14",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "15",
              "title": "Ort"
            }
          ]
        }
      }]
    }
  ]
}
